module.exports = __webpack_public_path__ + "static/media/overpass-bold-italic.a7525e62.ttf";